import {
    Briefcase,
    Brain,
    Apple,
    Flower2,
    MessageSquare,
    ClipboardList,
} from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const ICONS = [Briefcase, Brain, Apple, Flower2, MessageSquare, ClipboardList];

const Methods = () => {
    const { t } = useLanguage();
    return (
        <section
            id="methods"
            data-testid="methods-section"
            className="py-24 md:py-32 bg-gradient-to-b from-ella-sand to-ella-cream"
        >
            <div className="ella-container">
                <div className="max-w-2xl">
                    <span className="ella-overline" data-testid="methods-overline">
                        {t.methods.overline}
                    </span>
                    <h2
                        className="ella-headline text-4xl md:text-5xl lg:text-6xl mt-4 text-ella-ink"
                        data-testid="methods-title"
                    >
                        {t.methods.title}
                    </h2>
                    <p className="mt-6 text-lg text-ella-ink/70 font-light">
                        {t.methods.subtitle}
                    </p>
                </div>

                <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-ella-line overflow-hidden rounded-3xl border border-ella-line">
                    {t.methods.items.map((item, i) => {
                        const Icon = ICONS[i % ICONS.length];
                        return (
                            <article
                                key={i}
                                data-testid={`method-${i}`}
                                className="bg-white p-8 md:p-10 group hover:bg-ella-sand/40 transition-colors duration-500"
                            >
                                <div className="flex items-center justify-between">
                                    <span className="w-14 h-14 rounded-2xl bg-ella-ink/95 flex items-center justify-center text-ella-gold group-hover:bg-ella-gold group-hover:text-white transition-all duration-500">
                                        <Icon className="w-5 h-5" strokeWidth={1.4} />
                                    </span>
                                    <span className="font-display text-sm text-ella-muted tracking-[0.3em]">
                                        0{i + 1}
                                    </span>
                                </div>
                                <h3 className="font-display text-2xl md:text-[28px] mt-6 text-ella-ink leading-tight">
                                    {item.title}
                                </h3>
                                <p className="mt-4 text-ella-ink/70 leading-relaxed font-light text-[15px]">
                                    {item.desc}
                                </p>
                            </article>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default Methods;
